export default __webpack_public_path__ + "static/media/icon_tick.d4f9c086.svg";